import { SimpleTextParagraph } from 'app/src/shared/components'
import { useTranslation } from 'react-i18next'

export function MoreInfoSection() {
  const { t } = useTranslation('tutorial', { keyPrefix: 'Tutorial.MoreInfoSection' })
  return (
    <div className='pb-3'>
      <div className='text-[21px] font-bold leading-[31.5px]'>{t('Title')}</div>
      <SimpleTextParagraph txt={t('Text')} />
    </div>
  )
}
